export default [
  {
    name: 'overview',
    label: 'Overview',
    component: () => import('./Steps/OverviewStep'),
    navigation: {
      back: null,
      next: null,
      skip: null,
    },
  },
  {
    name: 'setup-same-account',
    label: 'Same Account Transfer',
    component: () => import('./Steps/SetupSameAccountStep'),
    navigation: {
      back: { label: 'Back', to: 'overview' },
      finish: { label: 'Change Email', to: null },
      skip: null,
    },
  },
  {
    name: 'setup-different-account',
    label: 'Different Account Transfer',
    component: () => import('./Steps/SetupDifferentAccountStep'),
    navigation: {
      back: { label: 'Back', to: 'overview' },
      finish: { label: 'Transfer Account', to: null },
      skip: null,
    },
  },
]
